"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ADMIN_PERMISSION_LABELS = void 0;
const enums_1 = require("../enums");
exports.ADMIN_PERMISSION_LABELS = {
  [enums_1.AdminPermission.Dashboard]: 'Dashboard',
  [enums_1.AdminPermission.Users]: 'Users',
  [enums_1.AdminPermission.CheckedInUsers]: 'Checked-in users',
  [enums_1.AdminPermission.Venues]: 'Venues',
  [enums_1.AdminPermission.Breadcrumbs]: 'Breadcrumbs',
  [enums_1.AdminPermission.Stickers]: 'Stickers',
  [enums_1.AdminPermission.Visits]: 'Visits',
  [enums_1.AdminPermission.Likes]: 'Likes',
  [enums_1.AdminPermission.Blocks]: 'Blocks',
  [enums_1.AdminPermission.Conversations]: 'Conversations',
  [enums_1.AdminPermission.Customers]: 'Customers',
  [enums_1.AdminPermission.Admin]: 'Administrators',
  [enums_1.AdminPermission.AuthenticatedAccounts]: 'Current logins',
  [enums_1.AdminPermission.AppLaunches]: 'App launches',
  [enums_1.AdminPermission.AuditLogs]: 'Audit logs',
  [enums_1.AdminPermission.FeatureFlags]: 'Feature flags',
  [enums_1.AdminPermission.DevTelephoneNumber]: 'Dev telephone numbers',
  [enums_1.AdminPermission.Reports]: 'Reports',
  [enums_1.AdminPermission.Jobs]: 'Scheduled jobs',
  [enums_1.AdminPermission.Notifications]: 'Notifications',
  [enums_1.AdminPermission.Comments]: 'Feedback',
  [enums_1.AdminPermission.Map]: 'Map',
  [enums_1.AdminPermission.Intentions]: 'Intentions',
  [enums_1.AdminPermission.Events]: 'Venue RSVPS',
  [enums_1.AdminPermission.SystemStatus]: 'System status',
  [enums_1.AdminPermission.PhotoVerification]: 'Photo verification',
  [enums_1.AdminPermission.Simulation]: 'Simulation',
  [enums_1.AdminPermission.Tickets]: 'Tickets'
};
//# sourceMappingURL=admin-permission-labels.js.map